export const WIN_MESSAGES = ['GG EZ', "Hylis wouldn't have done better!", 'Stronger than Granady!', 'Damn, are you a kb player?']
